import { gql } from "urql";
export const GetOrganizationImageUrlQuery = gql `
    query GetOrganizationImageUrl {
        organizations {
            organization {
                imageUrl
            }
        }
    }
`;
export const GetPriorityInvitesQuery = gql `
    query GetPriorityInvites($search: String, $offset: Int) {
        priorityInvites {
            priorityInvites(search: $search, offset: $offset) {
                priorityInviteId
                invitingUser {
                    userId
                    name
                    email
                    imageUrl
                }
                email
                isExpired
                acceptedAt
                createdAt
                updatedAt
            }
        }
    }
`;
export const GetPriorityInviteCountQuery = gql `
    query GetPriorityInviteCount($search: String) {
        priorityInvites {
            priorityInviteCount(search: $search)
        }
    }
`;
